// src/pages/Logout.tsx

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; // Import the useAuth hook
import { useCart } from '../context/CartContext'; // Import the cart context

const Logout: React.FC = () => {
    const { logout } = useAuth(); // Use the context login function

    const navigate = useNavigate();
    const { setCartItems } = useCart();

    const [ orderId, setOrderId ] = useState<number | null>(null);

    useEffect(() => {
        // Clear user data from local storage
        localStorage.removeItem('existingOrderId');
        localStorage.removeItem('checkedOutItems');
        localStorage.removeItem('selectedTable');
        localStorage.removeItem('orderId');

        // Explicitly reset state to ensure no leftover values
        setOrderId(null);  // Assuming `orderId` is a state variable
        setCartItems([]);   // Clear the cart
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        logout();
        // Redirect to login or home page
        navigate('/login'); // Change this to your desired route
    }, [navigate]);

    return (
        <div>
            <p>Logging out...</p>
        </div>
    );
};

export default Logout;